import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DictionaryModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { ScanBarcodeComponent } from './component/scan-barcode.component';
import { CommonLayoutModule } from '@sdbn/common';
import { CenteredScrollableContentModule } from '../centered-scrollable-content/centered-scrollable-content.module';



@NgModule({
  declarations: [
    ScanBarcodeComponent
  ],
  imports: [
    CommonModule,

    DictionaryModule,
    ApplicationClientCommonModule,
    CenteredScrollableContentModule,
    CommonLayoutModule,
    CommonTranslationModule

  ]
})
export class ScanBarcodeModule { }
